import PropTypes from "prop-types";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useLazyThumbnailLoader } from "../../helpers/review-images-helper";
import ReviewImagesWithMemberInfo from "./review-images-with-member-info";

export default function FeaturedReviewImageCarousel(props) {
  const { productId } = props;
  const containerRef = useRef(null);
  useLazyThumbnailLoader(containerRef, productId, 600);
  const momentsWithCount = useSelector(state => state.reviewsThumbnailPhotos);
  const reviewsCoverPhotos = momentsWithCount?.moments;

  const hasReviewCoverPhotoForStyle =
    Array.isArray(reviewsCoverPhotos) &&
    reviewsCoverPhotos.length > 0 &&
    reviewsCoverPhotos[0]?.styleName === props.productId; // this extra clause is to support product drawers

  if (!hasReviewCoverPhotoForStyle) {
    return;
  }

  return (
    <div
      ref={containerRef}
      className={`featured-review-image-carousel ${
        reviewsCoverPhotos.length === 1 ? "featured-review-image-carousel--single-child" : "snap-x snap-mandatory"
      }`}
      data-test-id="featured-review-image-carousel">
      <ReviewImagesWithMemberInfo reviewsCoverPhotos={reviewsCoverPhotos} />
    </div>
  );
}

FeaturedReviewImageCarousel.propTypes = {
  productId: PropTypes.string,
};
